import { useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import type { FiveStarReview } from 'components/Pages/AboutUsPage/Reviews/ReviewCard'
import ReviewCard from 'components/Pages/AboutUsPage/Reviews/ReviewCard'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import Group from 'components/utils/Group'
import styled from 'styled-components'
import { rem } from 'polished'

const reviews: Array<FiveStarReview> = [
  {
    content: 'Love using Luxury Escapes! Always offer fantastic escapes and deliver what is advertised. The service from staff is amazing. Nothing was too much trouble when we recently had to change a booking. Mitchell was very understanding and kept us informed of all our options and went the extra mile to help us. Highly recommend.',
    name: 'Vicky G',
    source: 'google',
  }, {
    content: 'As a newcomer to Luxury Escapes, I’ve found the whole process really easy and simple. I’ve been able to book awesome accommodation at a great price, and been supported in the most professional and friendly way by Mitchell R when I needed to extend my stay. Everything is sorted as we hoped – and the service we received was fantastic. Thanks Mitchell & the Luxury Escapes team!',
    name: 'Gavan W.',
    source: 'google',
  }, {
    content: 'Yet again another great holiday booking via Luxury Escapes. A personal thank you to Tammie R for sorting out our bookings to accommodate the kids and family. It truly took the stress out of booking and making changes to get it right. She was patient and kind. She actioned our requests promptly and followed up to keep us updated on what was going on in real time. A genuine thank you from us.',
    name: 'A Nazareth',
    source: 'trustpilot',
  }, {
    content: 'I have booked 2 trips with Luxury Escapes. The first was so amazing that we had to book again! I needed to get some additional information and called. Emily H. was so helpful. She gave me the different options and followed up. I highly recommend booking your next vacation with Luxury Escapes.',
    name: 'Stracy A.',
    source: 'google',
  }, {
    content: 'I’ve used Luxury Escapes on a number of occasions and each time I have called their support team, they have been fantastic. I called the other day with a question about my recent booking for a holiday and Bella M was very helpful and gave me all the information I needed quickly and efficiently. I would recommend Luxury Escapes to anyone who was thinking of a well-priced holiday with excellent customer service.',
    name: 'Gina T.',
    source: 'google',
  }, {
    content: 'They provided us with an exceptional value package for a stay at Avani+ resort in Khao Lak, Thailand. We were very well taken care of by the staff who recognised the booking from LE as important and even had a specially curated menu for LE guests.',
    name: 'Rawna',
    region: 'Singapore',
    source: 'trustpilot',
  }, {
    content: 'I would recommend Luxury Escapes and will definitely book through them again. The excellent customer service I received from Joseph F with my booking due to a flight change was friendly, knowledgeable, and most importantly, made me feel totally confident in my booking. Best customer service I’ve ever had anywhere, well done Joseph F.',
    name: 'Susan A.',
    source: 'google',
  }, {
    content: 'As a world traveler, the Botswana and Zambia safari is the best trip I have ever done. The accommodation was luxury, the staff and guides were amazing and the trip exceeded all my expectations. The parks were private so there were not many people. There were so many wild animals who were not afraid to get close. We saw the big 5. It was nature at its finest and Africa at its best. I felt privileged to be part of it.',
    name: 'Belinda G',
    region: 'Australia',
    source: 'trustpilot',
  }]

const Container = styled(Pane)`
  padding-bottom: ${rem(48)};
`

interface Props {
  title?: string
}

function Reviews({ title }: Props) {
  const intl = useIntl()

  const displayTitle = title ?? intl.formatMessage({
    id: 'iL8KZqvCP9MK8lm0KwDr',
    defaultMessage: 'Hear from our happy customers',
    description: 'About us page - customer reviews section heading on the about us page',
  })

  return (
    <Container>
      <Group direction="vertical" gap={32}>
        <LayoutContainer>
          <Heading variant="heading2">{displayTitle}</Heading>
        </LayoutContainer>
        <FullWidthCarousel snap="start" gap={32} itemsPerArrow={3}>
          {reviews.map((review, index) => (
            <ReviewCard key={index} {...review} />
          ))}
        </FullWidthCarousel>
      </Group>
    </Container>
  )
}

export default Reviews
